import { fetchAuthenticatedJson } from './authenticatedFetch';

function buildQuery(params = {}) {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') {
      return;
    }
    if (Array.isArray(value)) {
      if (!value.length) {
        return;
      }
      query.set(key, value.join(','));
      return;
    }
    query.set(key, value);
  });
  const queryString = query.toString();
  return queryString ? `?${queryString}` : '';
}

export function fetchPatternPerformanceSummary(filters = {}) {
  return fetchAuthenticatedJson(`/api/admin/pattern-performance${buildQuery(filters)}`);
}

export function fetchPatternPerformanceBreakdown(filters = {}) {
  return fetchAuthenticatedJson(`/api/admin/pattern-performance/by-score-bucket${buildQuery(filters)}`);
}

export function fetchPatternPerformanceComparison(filters = {}) {
  return fetchAuthenticatedJson(`/api/admin/pattern-performance/compare${buildQuery(filters)}`);
}

export function fetchPatternPerformanceDiagnostic(filters = {}) {
  return fetchAuthenticatedJson(`/api/admin/pattern-performance/diagnostic${buildQuery(filters)}`);
}

export function fetchPatternPerformanceEngineComparison(filters = {}) {
  return fetchAuthenticatedJson(`/api/admin/pattern-performance/engine-comparison${buildQuery(filters)}`);
}

export function fetchPatternPerformanceEngineComparisonDrilldown(filters = {}) {
  return fetchAuthenticatedJson(`/api/admin/pattern-performance/engine-comparison/drilldown${buildQuery(filters)}`);
}

export function fetchPatternPerformanceCalibration(filters = {}) {
  return fetchAuthenticatedJson(`/api/admin/pattern-performance/calibration${buildQuery(filters)}`);
}

export function fetchPatternPerformanceDetail(detectionId) {
  return fetchAuthenticatedJson(`/api/admin/pattern-performance/${detectionId}`);
}

export function cleanupPatternPerformanceDuplicates(filters = {}) {
  return fetchAuthenticatedJson(`/api/admin/pattern-performance/cleanup-duplicates${buildQuery(filters)}`, {
    method: 'POST',
  });
}

export function purgePatternPerformanceHistory(filters = {}) {
  return fetchAuthenticatedJson(`/api/admin/pattern-performance/purge-history${buildQuery(filters)}`, {
    method: 'POST',
  });
}

export function previewPatternScannerCleanup(filters = {}) {
  return fetchAuthenticatedJson(`/api/admin/pattern-scanner/cleanup/dry-run${buildQuery(filters)}`, {
    method: 'POST',
  });
}

export function executePatternScannerCleanup(filters = {}) {
  return fetchAuthenticatedJson(`/api/admin/pattern-scanner/cleanup/execute${buildQuery(filters)}`, {
    method: 'POST',
  });
}

export function rebuildPatternScannerBenchmark(filters = {}) {
  return fetchAuthenticatedJson(`/api/admin/pattern-scanner/benchmark/rebuild${buildQuery(filters)}`, {
    method: 'POST',
  });
}

export function purgeLegacyPatternPerformanceV1() {
  return fetchAuthenticatedJson('/api/admin/pattern-performance/purge-legacy-v1', {
    method: 'POST',
  });
}
